import React from "react";

import { Typography, Grid } from "@material-ui/core";

import useStyles from "./styles";

const ProfileDashboard = ({ data }) => {
  const { dRoot, dItem, dItemTitle, dItemNumber } = useStyles();

  return (
    <Grid item xs container className={dRoot}>
      {data.map(({ title, value }, i) => (
        <Grid item xs container className={dItem} key={i}>
          <Grid item>
            <Typography className={dItemNumber}>{value}</Typography>
          </Grid>
          <Grid item>
            <Typography className={dItemTitle}>{title}</Typography>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProfileDashboard;
